import React from 'react';
import {
    ModalHeader,
    ModalBody,
    ModalFooter,
    Button,
    Row,
    Col,
    Label,
    FormGroup,
} from 'reactstrap';
import Rodal from '../Rodal/Rodal';
import ButtonLoader from '../Layout/Buttons/ButtonLoader';
import './ConfirmationModal.scss';

const ConfirmationModal = ({
    isVisible,
    setIsVisible,
    header,
    confirmationText,
    loaderText = undefined,
    onConfirm,
    onCancel = undefined,
    params = undefined,
    nextButtonText,
    nextButtonLoaderText = undefined,
    cancelButtonText = undefined,
    isLoading = false,
    closeOnConfirm = true,
    isConfirmationDanger = false,
    className = undefined,
    hideCancelButton = false,
}) => {
    const animation = 'slideTop';

    const onConfirmClick = () => {
        onConfirm(params);
        if (closeOnConfirm) {
            setIsVisible(false);
        }
    };

    const onCancelClick = () => {
        onCancel?.(params);
        setIsVisible(false);
    };

    return (
        isVisible && (
            <Rodal
                visible={true}
                animation={animation}
                width={498}
                showCloseButton={false}
                onClose={() => {
                    setIsVisible(false);
                }}
                className={`confirmation-modal${className ? ` ${className}` : ''}`}>
                <ModalHeader>{header ?? 'Confirmation'}</ModalHeader>
                <FormGroup>
                    <ModalBody>
                        <Row>
                            <Col sm={12}>
                                <Label className="label-textarea">
                                    {loaderText && isLoading
                                        ? loaderText
                                        : confirmationText}
                                </Label>
                            </Col>
                        </Row>
                    </ModalBody>
                    <ModalFooter>
                        {!hideCancelButton && (
                            <Button
                                type="button"
                                className={
                                    isConfirmationDanger
                                        ? 'btn btn-primary'
                                        : 'btn-cancel'
                                }
                                onClick={() => {
                                    onCancelClick();
                                }}>
                                {cancelButtonText ?? 'Cancel'}
                            </Button>
                        )}
                        <ButtonLoader
                            className={
                                isConfirmationDanger
                                    ? 'btn btn-danger'
                                    : 'btn btn-primary'
                            }
                            buttonText={nextButtonText ?? 'Confirm'}
                            loaderButtonText={
                                nextButtonLoaderText ??
                                nextButtonText ??
                                'Confirm'
                            }
                            isLoading={isLoading}
                            onClick={() => {
                                onConfirmClick();
                            }}
                        />
                    </ModalFooter>
                </FormGroup>
            </Rodal>
        )
    );
};
export default ConfirmationModal;
